import { render, staticRenderFns } from "./DoctorSalesStat.vue?vue&type=template&id=4f374ede&scoped=true"
import script from "./DoctorSalesStat.vue?vue&type=script&lang=js"
export * from "./DoctorSalesStat.vue?vue&type=script&lang=js"
import style0 from "./DoctorSalesStat.vue?vue&type=style&index=0&id=4f374ede&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f374ede",
  null
  
)

export default component.exports